var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root" },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("automatic-reminders")))]),
      _vm.hasModuleAutomation
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-switch", {
                        attrs: {
                          space: "",
                          label: _vm.$ct("automatic-reminders-enabled"),
                        },
                        model: {
                          value: _vm.value.AutomaticRemindersEnabled,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "AutomaticRemindersEnabled",
                              $$v
                            )
                          },
                          expression: "value.AutomaticRemindersEnabled",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-switch", {
                        attrs: {
                          space: "",
                          label: _vm.$ct("add-read-confirmation"),
                        },
                        model: {
                          value: _vm.value.AutomaticReminderIncludeReadConfirm,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "AutomaticReminderIncludeReadConfirm",
                              $$v
                            )
                          },
                          expression:
                            "value.AutomaticReminderIncludeReadConfirm",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-all-users-mail-settings-autocomplete", {
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("to-use-mail-settings"),
                          "add-empty-value": "",
                          "empty-text": _vm.$ct("use-default-mail-settings"),
                        },
                        model: {
                          value:
                            _vm.value.AutomaticRemindersToUseMailSettingsID,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "AutomaticRemindersToUseMailSettingsID",
                              $$v
                            )
                          },
                          expression:
                            "value.AutomaticRemindersToUseMailSettingsID",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-weekday-select", {
                        attrs: {
                          disabled: !_vm.value.AutomaticRemindersEnabled,
                          "all-day": true,
                          fancy: "",
                          label: _vm.$ct("which-weekday"),
                          "use-go-days": "",
                        },
                        model: {
                          value: _vm.value.AutomaticReminderDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticReminderDays", $$v)
                          },
                          expression: "value.AutomaticReminderDays",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-date-picker", {
                        attrs: {
                          disabled: !_vm.value.AutomaticRemindersEnabled,
                          nullable: "",
                          fancy: "",
                          label: _vm.$ct("automatic-reminders-start-date"),
                          hint: _vm.$ct("automatic-reminders-start-date-hint"),
                        },
                        model: {
                          value: _vm.value.AutomaticRemindersStartDate,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.value,
                              "AutomaticRemindersStartDate",
                              $$v
                            )
                          },
                          expression: "value.AutomaticRemindersStartDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-switch", {
                        attrs: {
                          space: "",
                          label: _vm.$ct("grouped-reminders"),
                        },
                        model: {
                          value: _vm.value.AutomaticGroupReminders,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticGroupReminders", $$v)
                          },
                          expression: "value.AutomaticGroupReminders",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-row",
                { staticClass: "mt" },
                [
                  _c(
                    "w-col",
                    { staticClass: "center-text", attrs: { xs: "9", lg: "4" } },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("1st-reminder-after-days")) + " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "3", lg: "2" } },
                    [
                      _c("w-input-number", {
                        attrs: { decimals: 0, "calculate-decimals": 0 },
                        model: {
                          value: _vm.value.AutomaticSend1AfterDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticSend1AfterDays", $$v)
                          },
                          expression: "value.AutomaticSend1AfterDays",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { staticClass: "center-text", attrs: { xs: "9", lg: "4" } },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("2nd-reminder-after-days")) + " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "3", lg: "2" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          "has-error": !_vm.reminder2PeriodValid,
                          validators: [_vm.reminder2PeriodValidor],
                          "calculate-decimals": 0,
                        },
                        model: {
                          value: _vm.value.AutomaticSend2AfterDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticSend2AfterDays", $$v)
                          },
                          expression: "value.AutomaticSend2AfterDays",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { staticClass: "center-text", attrs: { xs: "9", lg: "4" } },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("3th-reminder-after-days")) + " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "3", lg: "2" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          "has-error": !_vm.reminder3PeriodValid,
                          validators: [_vm.reminder3PeriodValidor],
                          "calculate-decimals": 0,
                        },
                        model: {
                          value: _vm.value.AutomaticSend3AfterDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticSend3AfterDays", $$v)
                          },
                          expression: "value.AutomaticSend3AfterDays",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { staticClass: "center-text", attrs: { xs: "9", lg: "4" } },
                    [
                      _c("div", { staticClass: "text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("4th-reminder-after-days")) + " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "3", lg: "2" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          decimals: 0,
                          "has-error": !_vm.reminder4PeriodValid,
                          validators: [_vm.reminder4PeriodValidor],
                          "calculate-decimals": 0,
                        },
                        model: {
                          value: _vm.value.AutomaticSend4AfterDays,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticSend4AfterDays", $$v)
                          },
                          expression: "value.AutomaticSend4AfterDays",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { staticClass: "mt", attrs: { xs: "12" } },
                    [
                      _c("w-select", {
                        attrs: {
                          fancy: "",
                          items: _vm.layoutItems,
                          label: _vm.$ct("default-document-layout"),
                          validators: [_vm.layoutValidator],
                          "has-error": !_vm.isLayoutValid,
                        },
                        model: {
                          value: _vm.value.AutomaticLayoutID,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "AutomaticLayoutID", $$v)
                          },
                          expression: "value.AutomaticLayoutID",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-card-content",
            [
              _c("app-missing-module", {
                attrs: { "module-id": _vm.automationModule },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }